import { SsoProviderStrategy } from '~graphql/__generated__/types';

// SSO Service Type Enum
export enum SsoServiceType {
  OIDC = 'OIDC',
  SAML = 'SAML',
}

export const SSO_SERVICE_TO_STRATEGY: Record<SsoServiceType, SsoProviderStrategy> = {
  [SsoServiceType.OIDC]: SsoProviderStrategy.Oidc,
  [SsoServiceType.SAML]: SsoProviderStrategy.Samlp,
};

// Re-export existing types
export { Columns } from './types';
